<template>
  <div id="app">
    <router-view/>
    <BackToTop />
  </div>
</template>

<script>
import BackToTop from './components/BackToTop.vue';

export default {
  components: { BackToTop },
  data() {
    return {};
  },
  mounted() {
    // const bodyScale = () => {
    //   let devicewidth = document.documentElement.clientWidth//获取当前分辨率下的可是区域宽度
    //   let scale = devicewidth / 1920 // 分母——设计稿的尺寸
    //   document.body.style.zoom = scale//放大缩小相应倍数
    // }
    // bodyScale()
    // window.onresize = () => {
    //   return (() => {
    //     bodyScale()
    //   })()
    // }
    this.$nextTick(function() {
      // 适配不同屏幕，改变根font-size值
      if (document.documentElement.clientWidth <= document.documentElement.clientHeight) {
          document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
          // document.documentElement.style.fontSize = document.documentElement.clientWidth / 13.34 + 'px';
      } else {
          // document.documentElement.style.fontSize = document.documentElement.clientWidth / 13.34 + 'px';
      }
    })

  }
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
@import './css/reset.css'; */
@import './css/style.css';
</style>
